<template>
  <card-field-standard :list="list"></card-field-standard>
</template>

<script>
// 容器组件，在这里格式化验收标准的数据
import http from "@/utils/request.js";
import CardFieldStandard from "./components/CardFieldStandard.vue";
import { qmsUrl } from "@/config";

export default {
  name: "CardCheckStandard",
  components: { CardFieldStandard },
  data() {
    return {
      configTitleLists: [], // 列标题
      configChildrenLists: [], // 验收项目可以新增的行
      list: []
    };
  },
  props: {
    data: {
      type: Object
    }
  },
  computed: {},
  watch: {},
  async mounted() {
    this.getQcStandardTitle = await this.getQcStandardTitle();
    this.getQcStandardChild = await this.getQcStandardChild();
    // 格式化数据为视图组件需要的
    if (!this.data) return;
    const { cells } = this.data;

    // const _temp = [];
    const _itemLists = [];
    for (let i = 0; i < cells.length; i++) {
      const cellItem = cells[i];
      const _tempItem = {
        itemName: this.getValue(cellItem.PROJECT, "children"),
        itemList: [
          {
            categoryName: this.getValue(cellItem.CLASSIFY),
            categoryList: (() => {
              const _temp = [];
              // 将PROJECT,CLASSIFY去除掉的所有的属性
              Object.keys(cellItem).forEach(_key => {
                if (!["PROJECT", "CLASSIFY"].includes(_key)) {
                  _temp.push({
                    detailName: this.getValue({
                      value: _key,
                      valueSourceType: "DICT"
                    }),
                    detailDesc: cellItem[_key].value
                  });
                }
              });
              return _temp;
            })()
          }
        ]
      };
      _itemLists.push(_tempItem);
    }
    // 合并同一个project 原地修改数据
    for (let j = 1; j < _itemLists.length; ) {
      const _prevItem = _itemLists[j - 1];
      const _curItem = _itemLists[j];
      if (_prevItem.itemName === _curItem.itemName) {
        _prevItem.itemList = _prevItem.itemList.concat(_curItem.itemList);
        // 移除当前元素
        _itemLists.splice(j, 1);
      } else {
        j++;
      }
    }
    this.list = _itemLists;
  },
  methods: {
    // 获取验收标准标题
    async getQcStandardTitle() {
      const url = `${qmsUrl}/qms-service/api/standard/getQcStandardTitle`;
      const resp = await http.post(url, {});
      const { datas = [], success } = resp;
      if (success) return datas?.list;
      return [];
    },
    // 获取验收项目所有值
    async getQcStandardChild() {
      const url = `${qmsUrl}/qms-service/api/standard/getQcStandardChild`;
      const resp = await http.post(url, { no: "PROJECT" });
      const { datas = [], success } = resp;
      if (success) return datas?.list;
      return [];
    },
    // 如果是枚举则筛选枚举,如果是文本则显示文本
    getValue(obj, type) {
      const { value, valueSourceType } = obj;
      if (valueSourceType === "TEXT") return value;
      // 如果是project,则从getQcStandardChild筛选
      let _desc = "";
      if (type === "children") {
        this.getQcStandardChild.forEach(_title => {
          if (_title.code === value) {
            _desc = _title.name;
          }
        });
        return _desc;
      }
      // 从getQcStandardTitle筛选
      this.getQcStandardTitle.forEach(_title => {
        if (_title.code === value) {
          _desc = _title.name;
        }
      });
      return _desc;
    }
  }
};
</script>
<style lang="less"></style>
